// extracted by mini-css-extract-plugin
export default {"alerts_container":"App_alerts_container__YcyjH","actions_container":"App_actions_container__YD4qh","close":"App_close__ApTN9","alert_body":"App_alert_body__jPrSg"};